angular.module("ainapp")
    .controller("BuildingController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Buildings";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.BuildingsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Code: {
                                type: "string",
                                editable: false,
                            },
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            PlotNo: {
                                type: "string",
                                editable: false,
                            },
                            BuildingNo: {
                                type: "string",
                                editable: false,
                            },
                            Location: {
                                type: "string",
                                editable: false,
                            },
                            Status: {
                                type: "string",
                                editable: false,
                            },
                            PlotNo: {
                                type: "string",
                                editable: false,
                            },
                            "City.Name": {
                                type: "string",
                                editable: false,
                            },
                            "BuildingType.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Lessor.Name": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Code",
                        title: "Code",
                        }, {
                        field: "Name",
                        title: "Name",
                        },
                    {
                        field: "BuildingNo",
                        title: "Building No",
                        },
                    {
                        field: "City.Name",
                        title: "City",
                        },
                    {
                        field: "Location",
                        title: "Location",
                        },
                    {
                        field: "BuildingType.Name",
                        title: "Building Type",
                        },
                    {
                        field: "Lessor.Name",
                        title: "Lessor",
                        },
                    {
                        field: "Status",
                        title: "Status",
                        },
                    {
                        field: "PlotNo",
                        title: "Plot No",
                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeleteBuilding($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");
                    $.LoadingOverlay("hide");

                });
            }

            $scope.Edit = function (data) {
                $state.go("EditBuilding", {
                    BuildingId: data.Id
                })
            }



        }])
